/* Native dialogs; native Shopify forms and cart remain owned by Dawn. */
(() => {
  function openDialog(dialog, trigger) {
    if (!dialog) return;
    dialog._motiveTrigger = trigger;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = '';
      if (dialog._motiveTrigger?.isConnected) dialog._motiveTrigger.focus({ preventScroll: true });
    }, { once: true });
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-open-compare], [data-planner]');
    if (trigger) {
      if (trigger.hasAttribute('data-open-compare')) {
        openDialog(document.getElementById('MotiveCompare'), trigger);
      } else {
        const dialog = document.getElementById('MotivePlanner');
        if (dialog) {
          dialog.querySelector('[data-planner-title]').textContent = trigger.dataset.planner;
          dialog.querySelector('[data-planner-description]').textContent = trigger.dataset.description || '';
          openDialog(dialog, trigger);
        }
      }
    }
    const closer = event.target.closest('[data-close-dialog]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.tagName === 'DIALOG') {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    if (event.target.closest('.m-mobile-menu nav a')) event.target.closest('.m-mobile-menu').open = false;
  });
})();
